import { render } from "./ArchiveCases.vue?vue&type=template&id=f00aeac6"
import script from "./ArchiveCases.vue?vue&type=script&lang=js"
export * from "./ArchiveCases.vue?vue&type=script&lang=js"

import "./ArchiveCases.vue?vue&type=style&index=0&id=f00aeac6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ArchiveCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f00aeac6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f00aeac6', __exports__)) {
    console.log('reload')
    api.reload('f00aeac6', __exports__)
  }
  
  module.hot.accept("./ArchiveCases.vue?vue&type=template&id=f00aeac6", () => {
    console.log('re-render')
    api.rerender('f00aeac6', render)
  })

}


export default __exports__